module.exports = __webpack_public_path__ + "static/media/upload.58b5fe8a.svg";